import { Capability } from './capability-tags';

/**
 * For a given pathname, picks at least one capability group that is likely to be affected by
 * errors captured on that pathname.
 *
 * e.g. errors on '/login' are likely to affect something in the 'login' capability group.
 */
export const inferCapabilitiesFromPathname = (pathname: string): [Capability, ...Capability[]] => {
  if (pathname.includes('login')) {
    return ['capability-group--login'];
  }

  if (pathname.includes('signup')) {
    return ['capability-group--signup'];
  }

  if (pathname.includes('logout')) {
    return ['capability-group--logout'];
  }

  return ['unknown'];
};
